import { render, staticRenderFns } from "./PrestationTransfer.vue?vue&type=template&id=1f07518c&scoped=true"
import script from "./PrestationTransfer.vue?vue&type=script&lang=js"
export * from "./PrestationTransfer.vue?vue&type=script&lang=js"
import style0 from "./PrestationTransfer.vue?vue&type=style&index=0&id=1f07518c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f07518c",
  null
  
)

export default component.exports